//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Harris_Benedic',
  data() {
    return {
      form: {
        item1: '0',
        item2: '',
        item3: '',
        item4: '',
      },
      hasScore: false,
      disabled: false
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          console.log('form', form);
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      console.log('flag', flag);
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let result
        if (form.item1 == 0) {
          result = 66.47 + 13.75 * form.item3 + 5.003 * form.item2 - 6.775 * form.item4
        } else {
          result = 655.1 + 9.563 * form.item3 + 1.850 * form.item2 - 4.676 * form.item4

        }
        self.hasScore = true
        return String(result.toFixed(2))
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/Harris_Benedic.vue